import {ObjTools} from "./objTools";

/**
 * Ajax tools.
 */
export class AjaxTools {
    /**
     * Ajax action.
     * @param options options for ajax
     */
    static ajaxAction(options) {
        if (ObjTools.isNullyOrEmpty(options)) {
            throw('Specify options.');
        }

        if (ObjTools.isNullyOrEmpty(options.url)) {
            throw('Specify url.');
        }

        if (ObjTools.isNullyOrEmpty(options.onSuccess)) {
            options.onSuccess = function () {
            };
        }

        if (ObjTools.isNullyOrEmpty(options.onComplete)) {
            options.onComplete = function () {
            };
        }

        if (ObjTools.isNullyOrEmpty(options.processData)) {
            options.processData = true;
        }

        if (ObjTools.isNullyOrEmpty(options.onError)) {
            let that = this;

            options.onError = function (data) {
                let json = true;
                let respText = data['responseText'];
                try {
                    let respObj = JSON.parse(respText);
                    alert(respObj['error']);
                } catch (e) {
                    json = false;
                }
                if (!json) {
                    if (respText.trim() === '')
                        respText = "Server error";

                    alert(respText);
                }
            };
        }

        if (ObjTools.isNullyOrEmpty(options.method)) {
            options.method = 'get';
        }

        if (ObjTools.isNullyOrEmpty(options.async)) {
            options.async = true;
        }

        if (ObjTools.isNullyOrEmpty(options.data)) {
            options.data = {};
        }

        if (ObjTools.isNullyOrEmpty(options.headers)) {
            options.headers = {}
        }

        if (ObjTools.isNullyOrEmpty(options.data)) {
            options.data = null;
        }

        $.ajax({
            context: this,
            type: options.method,
            data: options.data,
            url: options.url,
            async: options.async,
            complete: options.onComplete,
            success: options.onSuccess,
            error: options.onError,
            headers: options.headers,
            contentType: options.contentType,
            processData: options.processData
        });
    };

    /**
     * Functie goPost.
     *
     * @param url url
     * @param dat date de pus in post
     * @param id id de formular pe care il va pune in dom (optional)
     * @param target target (_self, _blank) - optional, default _self
     */
    static goPost(url, dat, id, target) {
        // daca nu are id, e math.random
        id = typeof id !== 'undefined' ? id : Math.floor(Math.random() * 3571);

        // daca nu are target e _self
        target = typeof target !== 'undefined' ? target : "_self";

        let form_id = "post_form_" + id;

        $('#' + form_id).remove();

        let form_string = '<form action="' + url + '" method="post" target = "' + target + '" id="' + form_id + '" name="' + form_id + '">';

        for (const key in dat) {
            if (dat.hasOwnProperty(key)) {
                const val = dat[key];

                form_string += '<input type="hidden" name="' + key + '" id="' + key + '_' + id + '" value="' + val + '" />';

                if (key === 'req') {
                    const secObj = dat[key];

                    for (const secKey in secObj) {
                        if (secObj.hasOwnProperty(secKey)) {
                            const secVal = secObj[secKey];
                            form_string += '<input type="hidden" name="' + secKey + '" id="' + secKey + '_' + id + '" value="' + secVal + '" />';
                        }
                    }
                }
            }
        }

        form_string += '</form>';
        const form = $(form_string);
        $('body').append(form);
        $(form).submit();
    };
}

/**
 * Allow all cors headers
 */
AjaxTools.corsHeaders = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE, HEAD',
    'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Credentials, Access-Control-Allow-Methods, Origin, Accept, X-Requested-With, Content-Type, X-PINGOTHER, Authorization, X-CSRF-Token'
};